import { api } from '../../../lib/api'

export const GET_SUBSCRIPTIONS_BY_DOMAIN_REQUEST = 'GET_SUBSCRIPTIONS_BY_DOMAIN_REQUEST'
export const GET_SUBSCRIPTIONS_BY_DOMAIN_SUCCESS = 'GET_SUBSCRIPTIONS_BY_DOMAIN_SUCCESS'
export const GET_SUBSCRIPTIONS_BY_DOMAIN_FAILED = 'GET_SUBSCRIPTIONS_BY_DOMAIN_FAILED'

export const getSubscriptionsByDomain = function (domainId, onComplete) {
    return function (dispatch) {
        dispatch({
            type: GET_SUBSCRIPTIONS_BY_DOMAIN_REQUEST
        })
        api.getSubscriptionsByDomain(domainId).then(getSubscriptionsByDomainResponse => {
            dispatch({
                type: GET_SUBSCRIPTIONS_BY_DOMAIN_SUCCESS,
                payload: getSubscriptionsByDomainResponse
            })
            onComplete()
        }).catch(error => {
            dispatch({
                type: GET_SUBSCRIPTIONS_BY_DOMAIN_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscription/get-subscriptions-by-domain.js